import React, { Component } from 'react';
import { withRouter } from 'react-router';
import InsertFavoriteToDayplan from '@dietlabs/components/src/ApolloConnectors/FavMeals/InsertFavoriteToDayplan/InsertFavoriteToDayplanConnectorApollo';
import RemoveMealFromFavoritesConnectorApollo from '@dietlabs/components/src/ApolloConnectors/FavMeals/RemoveMealFromFavorites/RemoveMealFromFavoritesConnectorApollo';
import AddMealToFavoritesConnectorApollo from '@dietlabs/components/src/ApolloConnectors/FavMeals/AddMealToFavorites/AddMealToFavoritesConnectorApollo';
import FavMealsConnectorApollo from '@dietlabs/components/src/ApolloConnectors/FavMeals/Fetch/FavMealsConnectorApollo';
import FavMealsIndexContainer from './FavMealsIndexContainer';

class FavMealsIndex extends Component {
    render() {
        return (
            <FavMealsConnectorApollo>
                {({
                    cacheHit,
                    hasNetworkError,
                    lastAvailableDay,
                    ...favMealsData
                }) => (
                    <RemoveMealFromFavoritesConnectorApollo>
                        {({ removeMealFromFavorites }) => (
                            <AddMealToFavoritesConnectorApollo>
                                {({ addMealToFavorites }) => (
                                    <InsertFavoriteToDayplan>
                                        {({ insertFavoriteToDayplan }) => (
                                            <FavMealsIndexContainer
                                                lastAvailableDay={
                                                    lastAvailableDay
                                                }
                                                {...favMealsData}
                                                {...{
                                                    removeMealFromFavorites,
                                                }}
                                                {...{
                                                    addMealToFavorites,
                                                }}
                                                {...{
                                                    insertFavoriteToDayplan,
                                                }}
                                            />
                                        )}
                                    </InsertFavoriteToDayplan>
                                )}
                            </AddMealToFavoritesConnectorApollo>
                        )}
                    </RemoveMealFromFavoritesConnectorApollo>
                )}
            </FavMealsConnectorApollo>
        );
    }
}

export default withRouter(FavMealsIndex);
